import Icon from './icon';
import { lazyIcon } from './utils';

export { lazyIcon };
export default Icon;
